import { createGenericDispatcher } from '../../../../action/action-dispatcher-factory';
import { stripeBasePricesStatusSelectorV3 } from '../../../account-selectors';

import * as Api from '../../../../api/api';

export const loadBasePrices = () =>
  createGenericDispatcher({
    name: 'GET_STRIPE_BASE_PRICES_V3',
    loadFunction: () => Api.get('/account-billing/base-prices'),
    args: {},
    shouldExecuteSelector: (state: any) => stripeBasePricesStatusSelectorV3(state),
  });
